<template>
  <div class="groups-container">
    <b-row align-v="start">
      <b-col cols="12" lg="12" md="12" sm="12" xs="12" class="mb-3" v-for="group in groups" :key="group.id">
        <ul class="list-unstyled">
          <GroupsMedia  :type3="type2"  v-bind:group="group"></GroupsMedia>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GroupsMedia from './GroupsMedia'
export default {
  name: 'groups',
  data () {
    return {
      UserLogin: this.$store.state.user.login,
      groupsToBeFiltered: this.groups
    }
  },
  props: {
    'type2': String,
    'groups': Array
  },
  components: {
    GroupsMedia
  }
}

</script>

<style>
  .group-container {
    border: 1px solid #eeeff0;
    min-width: 240px
  }
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsList.vue